import React from 'react';
import VariableProximity from './VariableProximity';
import Dither from './Dither';
import ImageCarousel from './ImageCarousel';
import ImageCarousel2 from './ImageCarousel2';

const Experiences = ({ containerRef }) => {
  const commonProps = {
    fromFontVariationSettings: "'wght' 400, 'opsz' 9",
    toFontVariationSettings: "'wght' 600, 'opsz' 30",
    containerRef: containerRef,
    radius: 100,
    falloff: "linear"
  };

  return (
    <section className="experiences">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
        <Dither
          waveColor={[0.4, 0.4, 0.4]}
          disableAnimation={false}
          enableMouseInteraction={true}
          mouseRadius={1}
          colorNum={10}
          waveAmplitude={0.3}
          waveFrequency={3}
          waveSpeed={0.05}
          pixelSize={1}
        />
      </div>
      <div className="experiences-content">
        <h1>
          <VariableProximity
            label="Experiences"
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 900, 'opsz' 40"
            containerRef={containerRef}
            radius={180}
            falloff="linear"
          />
        </h1>
        
        <div className="first-paragraph-with-carousel">
          <ImageCarousel />
          <p>
          <VariableProximity label="My work has always grown " {...commonProps} />
          <VariableProximity label="from curiosity" className="highlight" {...commonProps} />
          <VariableProximity label=" about spaces, about people and about how " {...commonProps} />
          <VariableProximity label="design quietly shapes behavior" className="highlight" {...commonProps} />
          <VariableProximity label=". I first studied Retail and Exhibition Design, where I learned the practical side of building environments: planning flows, choosing materials, shaping atmospheres and making spaces work as well, " {...commonProps} />
          <VariableProximity label="as they feel alive" className="highlight" {...commonProps} />
          <VariableProximity label=". During that time, I interned as a retail designer and collaborated and worked on a museum that is based in India, " {...commonProps} />
          <VariableProximity label="that balanced" className="highlight" {...commonProps} />
          <VariableProximity label=" cultural storytelling with spatial design." {...commonProps} />
          </p>
        </div>
        <br />

        <div className="second-paragraph-with-carousel">
          <p>
            <VariableProximity label="After graduating, I stepped into the role of Junior Retail Designer, working with a variety of local and international brands. I designed showrooms and stores across malls and airports, gaining a deeper understanding of brand identity, user movement and " {...commonProps} />
            <VariableProximity label="the small decisions that drive how people interact" className="highlight" {...commonProps} />
            <VariableProximity label=" with physical environments. Wanting to understand the digital landscape more closely, I later joined an AI-powered digital marketing firm as an intern. It offered a completely different lens- one focused on strategy, user behavior and how data " {...commonProps} />
            <VariableProximity label="shapes experiences beyond the boundaries" className="highlight" {...commonProps} />
            <VariableProximity label=" of physical space." {...commonProps} />
          </p>
          <ImageCarousel2 />
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />

        <p>
          <VariableProximity label="Now, as a Master's student in Extended Reality Technologies at Arizona State University, my work spans XR (AR, VR, MR), 360° storytelling, projection mapping and real-time engines like Unreal Engine, Touch Designer, Pro Tools, Space Map Go and several other platforms. I'm exploring how digital worlds are built, how " {...commonProps} />
          <VariableProximity label="interactive layers can shift perception" className="highlight" {...commonProps} />
          <VariableProximity label=", and how " {...commonProps} />
          <VariableProximity label="spatial design translates into immersive media" className="highlight" {...commonProps} />
          <VariableProximity label=". My projects range from technical prototypes to narrative driven environments- each experimenting with how people engage with virtual space." {...commonProps} />
        </p>
        <br />

        <p>
          <VariableProximity label="This journey across physical design, digital strategy and now extended realities " {...commonProps} />
          <VariableProximity label="has shaped the way I think" className="highlight" {...commonProps} />
          <VariableProximity label=" about experience as a whole. Every project becomes a chance to blend structure with imagination and to create environments that feel intentional, responsive " {...commonProps} />
          <VariableProximity label="and alive" className="highlight" {...commonProps} />
          <VariableProximity label="." {...commonProps} />
        </p>

        <br /><br />

        {/* Experience 1 — Next Lab */}
        <h2 style={{ fontSize: '2.4rem', fontWeight: '600', color: '#4fa2fa', marginBottom: '0.5rem', textAlign: 'center' }}>
          <VariableProximity
            label="Part Time - 2025-2026"
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 700, 'opsz' 35"
            containerRef={containerRef}
            radius={120}
            falloff="linear"
          />
        </h2>
        <p style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <a
            href="https://nextlab.asu.edu/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4fa2fa', textDecoration: 'none', fontSize: '1.8rem', fontWeight: '600', borderBottom: '2px solid #4fa2fa', paddingBottom: '2px', pointerEvents: 'auto', cursor: 'pointer' }}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.open('https://nextlab.asu.edu/', '_blank', 'noopener,noreferrer'); }}
          >
            Next Lab →
          </a>
        </p>
        <p>
          <VariableProximity label="I work as a student worker at Next Lab, an interdisciplinary innovation studio at Arizona State University that explores emerging technologies and immersive media. I am part of the " {...commonProps} />
          <VariableProximity label="Technical Artistry, Modeling, Animation, and Concept (TAMAC) Guild" className="highlight" {...commonProps} />
          <VariableProximity label=", where we help " {...commonProps} />
          <VariableProximity label="transform ideas into explorable digital environments" className="highlight" {...commonProps} />
          <VariableProximity label=" and assets for immersive projects. My work involves contributing to 3D modeling, animation, and concept development while collaborating with other guilds to bring XR and interactive experiences to life. The guild works with industry-standard tools such as game engines and 3D software to design environments, characters, and visual elements for experimental and research-based projects. Working at Next Lab has " {...commonProps} />
          <VariableProximity label="given me hands-on experience in collaborative creative production and exposed me to interdisciplinary workflows" className="highlight" {...commonProps} />
          <VariableProximity label=" across art, technology, and design. It has also helped me develop practical skills in immersive media creation while working alongside other artists, developers, and researchers building future-focused technologies." {...commonProps} />
        </p>
        <div style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '2rem', pointerEvents: 'none' }}>
          <img
            src="/Images/exp.png"
            alt="Next Lab experience"
            style={{ maxWidth: '420px', width: '100%', borderRadius: '1.2rem', boxShadow: '0 4px 32px rgba(79,162,250,0.15)', display: 'inline-block' }}
          />
        </div>

        <br /><br />

        {/* Experience 2 — Mesh Labs */}
        <p style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <a
            href="https://mesh.lab.asu.edu/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4fa2fa', textDecoration: 'none', fontSize: '1.8rem', fontWeight: '600', borderBottom: '2px solid #4fa2fa', paddingBottom: '2px', pointerEvents: 'auto', cursor: 'pointer' }}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.open('https://mesh.lab.asu.edu/', '_blank', 'noopener,noreferrer'); }}
          >
            Mesh Labs →
          </a>
        </p>
        <p>
          <VariableProximity label="Student worker at MESH Labs, working with the " {...commonProps} />
          <VariableProximity label="Spatial Sound Production Guild and the Narrative & Concept Learning Guild" className="highlight" {...commonProps} />
          <VariableProximity label=". More details about the work and projects will be added here soon." {...commonProps} />
        </p>

        <br /><br />

        {/* Experience 3 — Live Beyond Stereo Grant */}
        <p style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <span style={{ color: '#4fa2fa', fontSize: '1.8rem', fontWeight: '600', borderBottom: '2px solid #4fa2fa', paddingBottom: '2px', display: 'inline-block' }}>
            Live Beyond Stereo Grant
          </span>
        </p>
        <p>
          <VariableProximity label="I contribute to a proof-of-concept grant at the ASU MIX Center that explores inclusive immersive audio-visual performance programming. As an " {...commonProps} />
          <VariableProximity label="Event Specialist and Visual Media Artist" className="highlight" {...commonProps} />
          <VariableProximity label=", I support the planning and " {...commonProps} />
          <VariableProximity label="execution of artist workshops and immersive music showcases" className="highlight" {...commonProps} />
          <VariableProximity label=" in the Enhanced Immersion Studio. My role involves developing visual media elements, coordinating event experiences, and assisting in the integration of spatial audio and projection technologies. The project " {...commonProps} />
          <VariableProximity label="aims to expand access" className="highlight" {...commonProps} />
          <VariableProximity label=" to immersive performance tools for emerging artists " {...commonProps} />
          <VariableProximity label="while testing scalable workflows for future of the immersive music events." className="highlight" {...commonProps} />
          <VariableProximity label=" More details to be added after the execution." {...commonProps} />
        </p>
      </div>
    </section>
  );
};

export default Experiences;
